<template>
    <div class="whitespace-nowrap [&:not(:hover)]:truncate hover:whitespace-normal ">
        {{ nextActionLabel }}
    </div>
</template>

<script setup>
import {ref, computed, defineProps, watch} from 'vue'

const props = defineProps([
    'nextStep'
])

const nextActionLabel = computed(() => {
    if(props.nextStep){
        if(props.nextStep.task_label){
            return `${props.nextStep.task_type.unresolved_label}/${props.nextStep.task_label}`
        }
        return props.nextStep.task_type.unresolved_label
    } else {
        return '--'
    }
})


</script>